import {
  COMMENT_VOTES_BUTTON_ACTIVE,
  COMMENT_VOTES_BUTTON_DOWNVOTE,
  COMMENT_VOTES_BUTTON_UPVOTE,
  COMMENT_VOTES_DOWNVOTES,
  COMMENT_VOTES_UPVOTES,
} from "../constants"

export default class CommentVotesEntity {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof CommentVotesEntity
   */
  static fromHtmlElement(htmlElement) {
    const upvoteButton = htmlElement.querySelector(COMMENT_VOTES_BUTTON_UPVOTE)
    const downvoteButton = htmlElement.querySelector(COMMENT_VOTES_BUTTON_DOWNVOTE)
    const upvotesElement = htmlElement.querySelector(COMMENT_VOTES_UPVOTES)
    const downvotesElement = htmlElement.querySelector(COMMENT_VOTES_DOWNVOTES)

    return new CommentVotesEntity({
      upvotes: Number(upvotesElement.textContent),
      downvotes: Number(downvotesElement.textContent),
      isUpvotedByUser: upvoteButton.classList.contains(COMMENT_VOTES_BUTTON_ACTIVE),
      isDownvotedByUser: downvoteButton.classList.contains(COMMENT_VOTES_BUTTON_ACTIVE),
    })
  }

  /**
   * @static
   * @param {object} json
   * @memberof CommentVotesEntity
   */
  static fromJson(json) {
    return new CommentVotesEntity({
      upvotes: json.upvotes,
      downvotes: json.downvotes,
      isUpvotedByUser: Boolean(json.user_upvoted),
      isDownvotedByUser: Boolean(json.user_downvoted),
    })
  }

  /**
   * Creates an instance of CommentVotesEntity.
   * @param {Object} settings
   * @param {Number} settings.upvotes
   * @param {Number} settings.downvotes
   * @param {Boolean} settings.isUpvotedByUser
   * @param {Boolean} settings.isDownvotedByUser
   * @memberof CommentVotesEntity
   */
  constructor({ upvotes, downvotes, isUpvotedByUser, isDownvotedByUser }) {
    this.upvotes = upvotes
    this.downvotes = downvotes
    this.isUpvotedByUser = isUpvotedByUser
    this.isDownvotedByUser = isDownvotedByUser
  }

  /**
   * @param {Object} settings
   * @param {Number} settings.upvotes
   * @param {Number} settings.downvotes
   * @param {Boolean} settings.isUpvotedByUser
   * @param {Boolean} settings.isDownvotedByUser
   * @returns {CommentVotesEntity} a copy with merged properties
   * @memberof CommentVotesEntity
   */
  copyWith({ upvotes, downvotes, isUpvotedByUser, isDownvotedByUser }) {
    return new CommentVotesEntity({
      upvotes: upvotes === undefined ? this.upvotes : upvotes,
      downvotes: downvotes === undefined ? this.downvotes : downvotes,
      isUpvotedByUser: isUpvotedByUser === undefined ? this.isUpvotedByUser : isUpvotedByUser,
      isDownvotedByUser:
        isDownvotedByUser === undefined ? this.isDownvotedByUser : isDownvotedByUser,
    })
  }
}
